module.exports = __webpack_public_path__ + "img/12.b9f732c7.png";